var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2a22 22 0 1 1 0 44 22 22 0 0 1 0-44z",
    fill: "#fffde5",
    stroke: "#fa9944",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12h4v16h-4z",
    fill: "#fa9944"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
    fill: "#fa9944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/WarningCircle.04305c3861e2fa857fbf12302e610af7.svg";
export { ForwardRef as ReactComponent };